import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

const lang = localStorage.getItem('i18nextLng') || 'ja';

i18n.use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: lang,
        lng: lang,
        debug: false,
        interpolation: {
            escapeValue: false,
            formatSeparator: ',',
        },
        ns: [
            'common',
            'navigation',
            'login',
            'dashboard',
            'systemAccount',
            'company',
            'profile',
            'auth',
            'companyAccount',
            'contract',
            'franchise',
            'store',
            'validateField',
            'validateMessage',
            'response',
            'validateName',
        ],
        backend: {
            loadPath: '/assets/i18n/{{ns}}/{{lng}}.json',
        },
        react: { useSuspense: true },
    });

export default i18n;
